import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {UOMUtil} from '../../utils/uomUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {ImportUtil} from '../../utils/importUtil.js';
import {RoutingService} from '../../service/routing/routingService.js';
import {BaseComponent} from '../basecomponent.js';
import {DataTools} from './dataTools.js';


/* global customElements */
class TripGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		var tripGrid = this;
		setTimeout(function(){
			tripGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var tripGrid = this;
	
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [				
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',					
					permissions: ['TRIP_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')						
					],
					listeners: {
						click: function() {
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['TRIP_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')						
					],
					listeners: {
						click: function() {
							actionAddEdit(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'showMap',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['TRIP_MANAGEMENT:READ'],
					children:[
						ElementUtil.makeIcon('vaadin:globe', ' Show on Map')						
					],
					listeners: {
						click: function() {
							actionShowMap(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'tools',
					'class': 'spacer-toolbar-item',
					disabled: true,
					children:[
						ElementUtil.makeIcon('vaadin:cog', ' Tools')						
					],
					properties: {
						menu: [
							{
								tag: 'dl-action-menu-item',
								itemId: 'transfer',							
								permissions: ['TRIP_MANAGEMENT:WRITE'],							
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:filter"></vaadin-icon> Add to GPS',
								listeners: {
									click: function(event) {
										actionTransferToGPS(grid.selectedItems);
									}
								}
							},
							{
								tag: 'dl-action-menu-item',
								itemId: 'reReference',							
								permissions: ['TRIP_MANAGEMENT:WRITE'],							
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:arrow-right"></vaadin-icon> Re-Reference',
								listeners: {
									click: function(event) {
										actionReReference(grid.selectedItems);
									}
								}
							},							
							{
								tag: 'dl-action-menu-item',
								itemId: 'timeshift',
								permissions: ['TRIP_MANAGEMENT:TIME_SHIFT'],							
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:clock"></vaadin-icon> Time Shift',
								listeners: {
									click: function(event) {
										actionTimeShift(grid.selectedItems);
									}
								}
							}
						]
					}
				},				
				{
					tag: 'div',
					style: 'float: right;',
					children:[						
						{
							tag: 'dl-action-button',
							itemid: 'bulk-tools',
							'class': 'spacer-toolbar-item',																
							children:[
								ElementUtil.makeIcon('vaadin:cogs', ' Bulk')						
							],
							properties: {
								menu: [																
									{
										tag: 'dl-action-menu-item',
										itemId: 'bulk-timeshift',
										permissions: ['TRIP_MANAGEMENT:TIME_SHIFT'],
										trustedInnerHTML: true,
										innerHTML: '<vaadin-icon icon="vaadin:clock"></vaadin-icon> Time Shift',
										listeners: {
											click: function(event) {
												actionTimeShiftBulk();
											}
										}
									},									
									{
										tag: 'hr'
									},
									{
										tag: 'dl-action-menu-item',
										itemId: 'bulk-delete',
										style: 'color: red',
										permissions: ['TRIP_MANAGEMENT:BULK_DELETE'],
										trustedInnerHTML: true,
										innerHTML: '<vaadin-icon icon="vaadin:trash"></vaadin-icon> Delete',
										listeners: {
											click: function(event) {
												actionBulkDelete();
											}
										}
									}
								]
							}
						},
						{
							tag: 'dl-action-button',
							itemid: 'upload',
							'class': 'spacer-toolbar-item',					
							permissions: ['TRIP_MANAGEMENT:WRITE'],						
							children:[
								ElementUtil.makeIcon('vaadin:upload', ' Import')						
							],
							listeners: {
								click: function() {
									actionUpload();
								}
							}							
						},
						{
							tag: 'span',
							innerHTML: '|'
						},
						{
							tag: 'dl-action-button',
							itemid: 'delete',
							'class': 'spacer-toolbar-item',	
							theme: 'error primary',
							permissions: ['TRIP_MANAGEMENT:DELETE'],							
							children:[
								ElementUtil.makeIcon('vaadin:trash', ' Delete')						
							],
							listeners: {
								click: function() {
									actionDelete(grid.selectedItems);
								}
							}							
						}
					]
				}											
			]
		});		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [
				{
					tag: 'vaadin-grid-selection-column',
					itemid: 'selectionColumn',
					'auto-select': true,
					'auto-width': true,
					listeners: {
						'select-all-changed': function() {
							gridSelectionChange();
						}
					}					
				},	
				{						
					path: 'tripRefNo',
					header: 'Trip Ref No',
					width: '7em'
				},
				{						
					path: 'tripStartDts',
					header: 'Start Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.tripStartDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},
				{						
					path: 'tripEndDts',
					header: 'End Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.tripEndDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},
				{						
					path: 'stops',
					header: 'Stop Count',
					width: '7em',
					'text-align': 'center',
					renderer: function(root, column, rowData) {			
						root.innerHTML = rowData.item.stops.length;						
					}
				},
				{						
					path: 'plannedDistance',
					header: 'Planned Distance',
					width: '7em',
					'text-align': 'end',
					renderer: function(root, column, rowData) {
						root.innerHTML = UOMUtil.sumTripStopDistances(rowData.item);
					}
				},
				{						
					path: 'actualDistance',
					header: 'Actual Distance',
					width: '7em',
					'text-align': 'end',
					renderer: function(root, column, rowData) {
						root.innerHTML = UOMUtil.sumFinalDistance(rowData.item.actualDistance.distances);
					}
				},
				{						
					path: 'tripComment',
					header: 'Trip Comment',
					width: '7em'
				},
				{						
					path: 'entryMethodDescription',
					header: 'Entry Method',
					width: '7em',
					hidden: true
				},				
				{						
					path: 'originalFilename',
					header: 'Original Filename',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'updateUser',
					header: 'Update User',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'updateDts',
					header: 'Update Date',
					width: '7em',
					hidden: true,
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
				},
				'click': function(e) {
					gridSelectionChange();
				}
			}
		});	
			
		var calcTotals = function(records) {			
			var totalDistance = 0;
			var totalToll = 0;
			var totalFerry = 0;
			records.forEach(function(record) {
				record.stops.forEach(function(stop) {
					stop.stopDistance.distances.forEach(function(d){
					var finalD = d.finalDistance;
					
					var distance = finalD.distance ? finalD.distance : 0;
					var toll = finalD.tollDistance ? finalD.tollDistance : 0;
					var ferry = finalD.ferryDistance ? record.ferryDistance : 0;

					if (record.distanceUom === 'KM') {
						totalDistance += UOMUtil.convertKMToMI(distance);
						totalToll += UOMUtil.convertKMToMI(toll);
						totalFerry += UOMUtil.convertKMToMI(ferry);
					} else {
						totalDistance += distance;
						totalToll += toll;
						totalFerry += ferry;
					}
					});
				});
				
			});
			return {
				totalDistance: Math.round(totalDistance * 10)/10,
				totalToll: Math.round(totalToll * 10)/10,
				totalFerry: Math.round(totalFerry * 10)/10
			};
		};	
			
		var gridSelectionChange = function() {
			setTimeout(function(){
				if (grid.selectedItems.length > 0) {
					ElementUtil.query(toolbar, 'tools').disabled = false;
					
					if (grid.selectedItems.length === 1) {
						ElementUtil.query(toolbar, 'edit').disabled = false;											
						ElementUtil.query(toolbar, 'transfer').disabled = false;
						ElementUtil.query(toolbar, 'reReference').disabled = false;
						ElementUtil.query(toolbar, 'timeshift').disabled = false;
						ElementUtil.query(toolbar, 'delete').disabled = false;						
						ElementUtil.query(toolbar, 'showMap').disabled = false;
					} else {
						ElementUtil.query(toolbar, 'edit').disabled = true;	
						ElementUtil.query(toolbar, 'transfer').disabled = false;
						ElementUtil.query(toolbar, 'reReference').disabled = false;
						ElementUtil.query(toolbar, 'timeshift').disabled = false;
						ElementUtil.query(toolbar, 'delete').disabled = false;
						ElementUtil.query(toolbar, 'showMap').disabled = true;
					}
					
					var totals = calcTotals(grid.selectedItems);					
					selectedDistanceStatus.innerHTML = '<b>Selected Distance:</b> ' + totals.totalDistance + 
							' Toll: ' + totals.totalToll + 
							' Ferry: ' + totals.totalFerry + 
							' MI | ';
				} else {						
					ElementUtil.query(toolbar, 'edit').disabled = true;	
					ElementUtil.query(toolbar, 'delete').disabled = true;
					ElementUtil.query(toolbar, 'tools').disabled = true;
					ElementUtil.query(toolbar, 'transfer').disabled = true;
					ElementUtil.query(toolbar, 'reReference').disabled = true;
					ElementUtil.query(toolbar, 'timeshift').disabled = true;
					ElementUtil.query(toolbar, 'showMap').disabled = true;
					
					selectedDistanceStatus.innerHTML = '';
				}					
			});
		};	
		
		var selectedDistanceStatus = ElementUtil.create({
			tag: 'span'
		});
		
		var distanceStatus = ElementUtil.create({
			tag: 'span',			
			trustedInnerHTML: true,
			innerHTML: '<b>Planned Distance:</b> 0 MI'
		});				
		
		var exportToolbar = ElementUtil.create({
			tag: 'dl-export-toolbar',
			itemid: 'trips',
			children: [
				{
					tag: 'span',
					slot: 'status',
					children: [
						selectedDistanceStatus,						
						distanceStatus
					]
				}
			],
			listeners: {
				ready: function() {
					exportToolbar.updateGrid(grid);
				},
				'click-detail': function() {
					var tractorId = ElementUtil.query(tripGrid.toolbarFilter, 'filterTractorId').value;
					if (tractorId) {
						DataManagementService.getTripService().exportTrips(tractorId, grid.currentFilter);
					} else {
						window.DL.MessageUtil.showToastError('A tractor must be selected');
					}
				}
			}
		});
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 100,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function() {
						
						var startFilterDts = TimeUtil.startOfDayCompanyTime(ElementUtil.query(tripGrid.toolbarFilter, 'filterStartDate').value);										
						var endFilterDts =  TimeUtil.endOfDayCompanyTime(ElementUtil.query(tripGrid.toolbarFilter, 'filterEndDate').value);		
									
						grid.currentFilter = {
							offset: pageRange.offset,
							max: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'tripStartDts',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',								
							start:  startFilterDts,														
							end: endFilterDts,
							filterField: 'tripRefNo',
							filterValue: ElementUtil.query(tripGrid.toolbarFilter, 'filterTripRefNo').value, 
							dateField: 'tripStartDts'
						};
																		
						var successHandler = function(records) {
							loadMask.remove();
							grid.activeItem = null;	
							grid.selectedItems = [];
							gridSelectionChange();
							
							grid.items = records.data;

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();
							
							var totals = calcTotals(records.data);					
							distanceStatus.innerHTML = '<b>Planned Distance:</b> ' + totals.totalDistance + 
							' Toll: ' + totals.totalToll + 
							' Ferry: ' + totals.totalFerry + 
							' MI | ';				
						};
						
						var tractorId = ElementUtil.query(tripGrid.toolbarFilter, 'filterTractorId').value;
						if (tractorId) {						
							DataManagementService.getTripService().getTrips(tractorId, grid.currentFilter).then(function(records){
								successHandler(records);
							});						
						} else {
							loadMask.remove();
							if (tripGrid.nextLoadOfGrid) {
								ElementUtil.query(tripGrid.toolbarFilter, 'filterTractorId').validate();								
								window.DL.MessageUtil.showToastError('A tractor must be selected');
							} else {
								tripGrid.nextLoadOfGrid = true;
							}
						}
						
					};	
					
					loadData();														
				};
			},
			listeners: {
				ready: function() {					
					//pagingToolbar.loadCurrentPage();					
				}
			}
			
		});			
		
		var footerContainer = ElementUtil.create({
			tag: 'div',
			slot: 'footer',
			children: [
				exportToolbar,
				{
					tag: 'div',
					style: 'border-top: 1px solid lightgrey;'
				},
				pagingToolbar
			]
		});
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footerContainer
			]
		});		
		tripGrid.append(flexLayout);	

		tripGrid.actionRefresh = function() {
			pagingToolbar.loadPage(1);
		};
		
		var actionAddEdit = function(record) {
		
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: record ? 'Edit Trip' : 'Add Trip',
				icon: 'vaadin:edit',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						addEditWin.show();
												
						var loadReferenceNo = function (lookupValue, cbToPopulate, callback) {
							var paging = {
								max: 100
							};
							if (lookupValue) {
								paging.filterField = 'description';
								paging.filterValue = lookupValue;
							}
							UnitService.getUnitLookupService().getUnits('TRACTOR', paging).then(function (units) {
								cbToPopulate.items = units.data;
								if (callback) {
									callback(cbToPopulate);
								}
							});

						};
												
						var stopToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',							
							children: [
								{
									tag: 'dl-action-button',
									itemid: 'add',
									theme: 'primary',
									'class': 'spacer-toolbar-item',					
									permissions: ['TRIP_MANAGEMENT:WRITE'],
									children:[
										ElementUtil.makeIcon('vaadin:plus', ' Add')						
									],
									listeners: {
										click: function() {
											addEditStop();
										}
									}					
								},
								{
									tag: 'dl-action-button',
									itemid: 'edit',
									'class': 'spacer-toolbar-item',
									disabled: true,	
									permissions: ['TRIP_MANAGEMENT:WRITE'],
									children:[
										ElementUtil.makeIcon('vaadin:edit', ' Edit')						
									],
									listeners: {
										click: function() {
											addEditStop(stopsGrid.selectedItems[0]);
										}
									}					
								},
								{
									tag: 'div',
									style: 'float: right;',
									children:[											
										{
											tag: 'dl-action-button',
											itemid: 'delete',
											disabled: true,
											theme: 'error primary',
											'class': 'spacer-toolbar-item',					
											permissions: ['UNITGROUP_MANAGEMENT:WRITE'], //this is intentional							
											children:[
												ElementUtil.makeIcon('vaadin:trash', 'Remove')						
											],
											listeners: {
												click: function() {
													deleteStop(stopsGrid.selectedItems[0]);
												}
											}							
										}
									]
								}											
							]
						});							
						
						var stops = [];						
						var stopsGrid =  ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'wrap-cell-content row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',							
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true,
								listeners: {
									'direction-changed': function (event) {
										if (event.detail && event.detail.value) {
											stopsGrid.currentSortField = event.target.path;
											stopsGrid.currentSortDirection = event.detail.value.toUpperCase();										
										}
									}
								}
							},
							children: [
								{
									path: 'arrivalDts',
									header: 'Arrival Dts',
									width: '7em',
									renderer: function(root, column, rowData) {
										var date = TimeUtil.parseDate(rowData.item.arrivalDts);						
										root.innerHTML = TimeUtil.formatDateStandard(date);						
									}
								},
								{
									path: 'departureDts',
									header: 'Departure Dts',
									width: '7em',
									renderer: function(root, column, rowData) {
										var date = TimeUtil.parseDate(rowData.item.departureDts);						
										root.innerHTML = TimeUtil.formatDateStandard(date);						
									}
								},
								{
									path: 'stopType',
									header: 'Stop Type',
									width: '5em',
									'text-align': 'center'
								},
								{
									path: 'rawLocation',
									header: 'Raw Location',
									width: '7em'
								},
								{
									path: 'stopComment',
									header: 'Comment',
									width: '7em'
								}
							],
							listeners: {
								'active-item-changed': function (event) {
									const item = event.detail.value;
									stopsGrid.selectedItems = item ? [item] : [];
									if (stopsGrid.selectedItems.length > 0) {
										ElementUtil.query(stopToolbar, 'edit').disabled = false;
										ElementUtil.query(stopToolbar, 'delete').disabled = false;
									} else {
										ElementUtil.query(stopToolbar, 'edit').disabled = true;
										ElementUtil.query(stopToolbar, 'delete').disabled = true;
									}
								}
							}
						});
												
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [										
										{
											tag: 'vaadin-combo-box',
											itemid: 'tractorId',
											label: 'Tractor',
											name: 'tractorId',
											'item-value-path': 'code',
											'item-label-path': 'description',
											required: true,											
											postinit: function (combo) {												
											},
											listeners: {
												input: {
													fn: function (e) {
														var refNoCB = ElementUtil.query(formPanel, 'tractorId');
														loadReferenceNo(ElementUtil.resolveComboInputValue(e, refNoCB), refNoCB);															
													},
													buffer: 500
												}
											}
										},
										{
											tag: 'vaadin-text-field',										
											name: 'tripRefNo',
											label: 'Trip Ref No',
											required: true,	
											maxLength: 80											
										},
										{
											tag: 'div',
											style: 'height: 300px;',
											colspan: 2,
											children: [
												{
													tag: 'dl-flex-layout',
													children: [
														stopToolbar,
														stopsGrid
													]
												}
											]
										},										
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
																			
															if (stops.length < 1) {
																window.DL.MessageUtil.showOkMessage('Must have at least 1 stop.');																
															} else {															
																formPanel.submitForm({
																	preSubmit: function(data) {																	
																		data.stops = stops;
																		return data;
																	},
																	actualCall: function(data) {			
																		if (record) {
																			data.recordId = record.recordId;
																		}																	

																		return DataManagementService.getTripService().saveTrip(data, (record ? true : false));
																	},
																	success: function(data, responseData) {
																		window.DL.MessageUtil.showToast('Success', 'Saved Trip', {
																			theme: 'success',
																			position: 'top-stretch'
																		});
																		tripGrid.actionRefresh();
																		addEditWin.close();
																	}
																});	
															}
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);
						
						var actionRefreshStops = function() {
							stopsGrid.activeItem = null;
							stopsGrid.items = stops.slice(0);							
						};
						
						var addEditStop = function(stop) {
							
							var addEditStopWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: (stop ? 'Edit Stop' : 'Add Stop'),
								icon: 'vaadin:edit',
								width: 700,
								height: 400,
								listeners: {
									ready: function () {
										addEditStopWin.show();
										
										var stopFormPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-form-layout',
													children: [
														{
															tag: 'vaadin-date-time-picker',
															label: 'Arrival Date(mm/dd/yyyy hh:mm:ss)',
															name: 'arrivalDts',
															step: 1,
															required: true
														},
														{
															tag: 'vaadin-date-time-picker',
															label: 'Departure Date(mm/dd/yyyy hh:mm:ss)',
															name: 'departureDts',
															step: 1
														},
														{
															tag: 'vaadin-combo-box',
															itemid: 'timezoneCB',
															label: 'TimeZone',
															name: 'timezone',
															'item-value-path': 'code',
															'item-label-path': 'description',
															value: TimeUtil.getCompanyTimeZoneNameOnly(),
															postinit: function (combo) {
																Service.getLookupService().getLookupValues('TimeZone').then(function (data) {
																	combo.items = data;
																});
															}											
														},
														{
															tag: 'vaadin-combo-box',
															label: 'Stop Type',
															name: 'stopType',
															'item-value-path': 'code',
															'item-label-path': 'description',															
															value: 'PICKUP',
															postinit: function (combo) {
																Service.getLookupService().getLookupValues('TripStopType').then(function (data) {
																	combo.items = data;
																	combo.required = true;
																});
															}
														},
														{
															tag: 'div',
															children: [
																{
																	tag: 'dl-location-lookup',
																	itemid: 'locationLookup',
																	textstyle: 'width: calc(100% - 40px)',
																	name: 'rawLocation',
																	required: true
																}
															]
														},
														{
															tag: 'vaadin-text-field',
															name: 'stopComment',
															label: 'Comment',
															colspan: 2,
															maxLength: 255
														},
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:database', (stop ? ' Update' : ' Add'))
																	],
																	listeners: {
																		click: function () {

																			if (stopFormPanel.isValid()) {
																				
																				var timezone = ElementUtil.query(stopFormPanel, 'timezoneCB').value;
																				var options = {
																					timeZone: timezone
																				};
																			
																				var data = stopFormPanel.getData(options);
																				
																				if (stop) {
																					stop.arrivalDts = data.arrivalDts;
																					stop.departureDts = data.departureDts;
																					stop.rawLocation = data.rawLocation;
																					stop.stopComment = data.stopComment;
																					stop.stopType = data.stopType;
																				} else {
																					stops.push(data);	
																				}
																				actionRefreshStops();
																				addEditStopWin.close();
																			}

																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function () {
																			//cancel
																			addEditStopWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]
										});

										addEditStopWin.addToContentElement(stopFormPanel);
										
										if (stop) {		
											//wait for render; shift to end of event loop for location to pickup
											setTimeout(function() {											
												stopFormPanel.load(stop);
												var locationLookup = ElementUtil.query(stopFormPanel, 'locationLookup');
												var locationTextField = locationLookup ? ElementUtil.query(locationLookup, 'text') : null;
												if (locationTextField && stop.location) {
													var hasAddress = !!stop.location.addressLine1;
													var hasLatLong = stop.location.latitude && stop.location.longitude;
													if (hasAddress && hasLatLong) {
														locationTextField.helperText = stop.location.latitude + ', ' + stop.location.longitude;
													} else if (!hasAddress && hasLatLong) {
														var locationHelperParts = [];
														if (stop.location.city) {
															locationHelperParts.push(stop.location.city);
														}
														if (stop.location.stateProv) {
															locationHelperParts.push(stop.location.stateProv);
														}
														locationTextField.helperText = locationHelperParts.join(' ');
													} else {
														locationTextField.helperText = '';
													}
												}
											});
										}
										
									}
								}
							});
							
						};
						
						var deleteStop = function(stop) {
							window.DL.MessageUtil.showConfirm({
								title: 'Confirm Delete',
								message: 'Are you sure you want to delete selected stop?',
								buttons: [
									{
										text: 'Yes',
										handler: function() {
											
											var stopsToKeep = [];
											stops.forEach(function(s){
												var keep = true;												
												if (s.arrivalDts === stop.arrivalDts && 
													s.rawLocation === stop.rawLocation && 
													s.stopComment === stop.stopComment && 
													s.stopType === stop.stopType) {												
													keep = false;
												}
												if (keep) {
													stopsToKeep.push(s);
												}
											});
											stops = stopsToKeep;
											actionRefreshStops();					
										}
									},
									{
										text: 'No'
									}
								]
							});							
						};
						
						var updateTractorCB = function() {
							var tractorIdFilter = ElementUtil.query(tripGrid.toolbarFilter, 'filterTractorId').selectedItem;
							var initialValue = null;
							if (tractorIdFilter) {
								initialValue = tractorIdFilter.description;
							}
							var refNoCB = ElementUtil.query(formPanel, 'tractorId');	
							loadReferenceNo(initialValue, refNoCB, function(cb) {
								if (tractorIdFilter) { 
									refNoCB.value = tractorIdFilter.code;
								}
							});
						};
						
						if (record) {								
							//wait for render; shift to end of event loop
							setTimeout(function() {
								formPanel.load(record);		
								
								stops = record.stops.slice(0);
								stops.forEach(function(stop){
									var hasAddress = stop.location && !!stop.location.addressLine1;
									var hasLatLong = stop.location && stop.location.latitude && stop.location.longitude;
									if (hasAddress) {
										var addressLocationParts = [stop.location.addressLine1];
										if (stop.location.city) {
											addressLocationParts.push(stop.location.city);
										}
										if (stop.location.stateProv) {
											addressLocationParts.push(stop.location.stateProv);
										}
										stop.rawLocation = addressLocationParts.join(', ');
									} else if (hasLatLong) {
										stop.rawLocation = stop.location.latitude + ', ' + stop.location.longitude;
									} else if (stop.location && stop.location.stateProv) {
										stop.rawLocation = stop.location.stateProv + '-' + (stop.location.country || '');
									}
								});
								
								actionRefreshStops();		
								
								updateTractorCB();		
							});
						} else {
							updateTractorCB();							
						}
						
					}
				}
			});			
			
		};
		
		var actionDelete = function(records) {
			
			var multipleIds = {
				ids: []
			};
			records.forEach(function(record){
				multipleIds.ids.push(
					record.recordId
				);
			});
	
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete selected records?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing...');

							DataManagementService.getTripService().deleteTrips(multipleIds)
							.then(function(result){
								loadMask.remove();
								window.DL.MessageUtil.showDeleteRecordsResult(result);
								var refreshEvent = new CustomEvent('refresh-all', { detail: '' });
								tripGrid.dispatchEvent(refreshEvent);							
								
							})
							.catch(function(error){
								loadMask.remove();
							});
						}
					},
					{
						text: 'No'
					}
				]
			});
			
			
		};
		
		var actionUpload = function() {
			ImportUtil.showUpload({
				dataTypes: 'TRIP',				
				uploadUrl: '/api/resource/trips/import'
			});
		};	
		
		var actionShowMap = function(record) {
			var mapWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Map',
				icon: 'vaadin:globe',
				width: .75,
				height: .75,
				listeners: {
					ready: function() {
						mapWin.show();
						
						var toolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',
							children: [								
								{
									tag: 'dl-action-button',					
									'class': 'spacer-toolbar-item',
									style: 'width: 225px;',
									permissions: [],
									children:[
										ElementUtil.makeIcon('vaadin:cogs', ' View')
									],
									properties: {
										menu: [
											{
												tag: 'vaadin-item',						
												innerHTML: 'Show Satellite',
												listeners: {
													click: function(event) {
														map.showSatellite();
													}
												}
											},
											{
												tag: 'vaadin-item',						
												innerHTML: 'Show Terrain',
												listeners: {
													click: function(event) {
														map.showTerrain();
													}
												}
											},
											{
												tag: 'vaadin-item',						
												innerHTML: 'Show Transportation',
												listeners: {
													click: function(event) {
														map.showTransportation();
													}
												}
											}

										]
									}					
								}								
							]
						});						
						
						var map = ElementUtil.create({
							tag: 'dl-map-panel',
							slot: 'primary',
							style: 'width: 100%; height: 100%'
						});

						var mapFlexLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								toolbar,
								map				
							]
						});	
						
						mapWin.addToContentElement(mapFlexLayout);
						
						//if 1 record; plot point
						setTimeout(function(){
							if (record.stops.length === 1) {		
								var stop = record.stops[0];
								var longLats = [stop.location.longitude, stop.location.latitude];

								var date = TimeUtil.parseDate(stop.recordDts);						
								var info = TimeUtil.formatDateStandard(date) + '<br>' 
										+ stop.location.addressLine1 + ' ' + stop.location.city + ', ' + stop.location.stateProv + ' ' + stop.location.country + '<br>'
										+ stop.location.latitude + ', ' + stop.location.longitude;

								map.addMarker(longLats, {
									popupHTML: info
								});
								setTimeout(function() {
									map.zoomOnPoint(longLats);
								}, 1000);
							} else {
								record.stops.sort(function(a, b){
									return TimeUtil.compare(a.arrivalDts, b.arrivalDts);
								});
																							
								var loadMask = map.showLoading('Get Routing Options...');
								RoutingService.getGeospatialOptionsService().getOptionsForCurrentCompany().then(function (routeOptions) {
									loadMask.remove();

									var request = map.translateRoutingOptions(routeOptions);
									request.routeId = ElementUtil.nextId();
									request.stops = [];

									record.stops.forEach(function (stop) {
										request.stops.push({
											longitude: stop.location.longitude,
											latitude: stop.location.latitude
										});
									});

									map.route(request);
								});								
								
							}
						}, 200);						

					}
				}
			});
		};
				
		var actionTransferToGPS = function(records) {
			var tractorId = ElementUtil.query(tripGrid.toolbarFilter, 'filterTractorId').value;
			
			var request = {
				originReferenceType: 'TRACTOR',
				originReferenceId: tractorId,
				tractorIdTransferTo: tractorId,  //For now transfer just the same...most likely the desired case
				dataIds: []				
			};
			records.forEach(function(record){
				request.dataIds.push(
					record.recordId
				);
			});
	
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm GPS Creation',
				message: 'Are you sure you want to create GPS locations for the selected records?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Creating GPS Records...');

							DataManagementService.getTripService().transferTripsToGPS(request)
							.then(function(results){
								loadMask.remove();
						
								if (results.success) {
									window.DL.MessageUtil.showToast('Success', 'Trips: ' + request.dataIds.length + ' transferred to GPS records.', {									
										theme: 'success'
									});
									tripGrid.actionRefresh();
								}
							})
							.catch(function(error){
								loadMask.remove();
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});				
		};
		
		var actionTimeShift = function(records) {
			var unitId = records[0].tractorId;			
			records.sort(function(a, b) {
				return TimeUtil.compare(a.arrivalDts, b.arrivalDts);	
			});
						
			var startDts = records[0].tripStartDts;
			var endDts = records[records.length-1].tripEndDts;
						
			DataTools.timeShiftData({				
				proceed: function(data, successCallback, failCallback) {					
					data.dataType = 'TRIP';		
					data.dataStartDts = startDts;
					data.dataEndDts = endDts;
					data.unitSelection = {
						type: 'CUSTOM',
						customList: [
							{
								unitId: unitId,
								referenceType: 'TRACTOR'
							}
						]
					};
					
					DataManagementService.getTripService().timeshiftTrip(data).then(function(result){
						if (result.success) {							
							var refreshEvent = new CustomEvent('refresh-all', { detail: '' });
							tripGrid.dispatchEvent(refreshEvent);							

							if (successCallback) {
								successCallback(result);
							}							
						} else {														
							if (failCallback) {
								failCallback(result);
							}
						}
					});
				}
			});			
		};
		
		var actionReReference = function(records) {
			var primaryRecord = records[0];
			
			DataTools.referenceData({
				originalUnitId: primaryRecord.tractorId,
				referenceTypeOrigin: 'TRACTOR',
				referenceTypeFixed: true,
				proceed: function(data, successCallback, failCallback) {
					
					var recordIds = [];
					records.forEach(function(record) {
						recordIds.push(record.recordId);
					});
					
					var transferRequest = {
						referenceTypeOrigin: 'TRACTOR',
						referenceTypeDestination: 'TRACTOR',
						originalUnitId: primaryRecord.tractorId,
						destinationUnitId: data.destinationUnitId,
						dataToReReference: recordIds
					};
					
					DataManagementService.getTripService().reReferenceTrip(transferRequest).then(function(result){
						if (result.success) {													
							var refreshEvent = new CustomEvent('refresh-all', { detail: '' });
							tripGrid.dispatchEvent(refreshEvent);							
							
							if (successCallback) {
								successCallback(result);
							}							
						} else {														
							if (failCallback) {
								failCallback(result);
							}
						}
					});
					
				} 
			});			
		};

		var actionTimeShiftBulk = function() {
			DataTools.timeShiftData({
				bulk: true,
				proceed: function(data, successCallback, failCallback) {					
					data.dataType = 'TRIP';					
										
					DataManagementService.getTripService().timeshiftTrip(data).then(function(result){
						if (result.success) {							
							var refreshEvent = new CustomEvent('refresh-all', { detail: '' });
							tripGrid.dispatchEvent(refreshEvent);							

							if (successCallback) {
								successCallback(result);
							}							
						} else {														
							if (failCallback) {
								failCallback(result);
							}
						}
					});
				}
			});			
		};
		
		var actionBulkDelete = function() {
			DataTools.deleteData({
				bulk: true,
				proceed: function(data, successCallback, failCallback) {	
					
					DataManagementService.getTripService().deleteBulkTrips(data).then(function(result){
						if (result.success) {							
							var refreshEvent = new CustomEvent('refresh-all', { detail: '' });
							tripGrid.dispatchEvent(refreshEvent);							

							if (successCallback) {
								successCallback(result);
							}							
						} else {														
							if (failCallback) {
								failCallback(result);
							}
						}
					});
				}
			});			
		};
		
	}
	
	refreshGrid() {
		var tripGrid = this;		
		tripGrid.actionRefresh();
	}
	
	setFilterContainer(filterContainer) {
		var tripGrid = this;		
		tripGrid.toolbarFilter = filterContainer;
	}
	
}
customElements.define('dl-trip-grid', TripGrid);